// 02.3-client.md paso c -- plantillas de correo de cotización (HTML embebido), extraídas de
// RichTextEditor.jsx: era ~200 líneas de dato puro (un string de plantilla), no lógica del
// editor -- inflaba el conteo del archivo hacia el cap de 500 sin ser parte del motor de
// contentEditable/execCommand/Selection/Range. CON_RENTA_TEMPLATE/PRO_TEMPLATE se derivan de
// COMPRA_SIMPLE_TEMPLATE via .replace() -- comportamiento preservado verbatim, solo se movió
// la ubicación.
export const COMPRA_SIMPLE_TEMPLATE = `<!DOCTYPE html>
<html lang="es">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Cotización de Terminales</title>
  <style>
    * { margin: 0; padding: 0; box-sizing: border-box; }
    body { background: #ffffff; font-family: 'DM Sans', sans-serif; color: #2c2c2c; padding: 32px 16px; }
    .email-wrapper { max-width: 680px; margin: 0 auto; background: #ffffff; border-radius: 6px; overflow: hidden; box-shadow: 0 8px 48px rgba(100,110,140,0.13); border: 1px solid #e2e8f0; }
    .header { background: #ffffff; padding: 48px 48px 36px; border-bottom: 1px solid #e2e8f0; }
    .header-top { display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 32px; }
    .brand { display: flex; align-items: center; gap: 12px; }
    .brand-icon { width: 46px; height: 46px; background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 12px; display: flex; align-items: center; justify-content: center; font-size: 22px; }
    .brand-name { font-family: 'Playfair Display', serif; color: #1e293b; font-size: 22px; }
    .brand-tagline { color: #64748b; font-size: 11px; text-transform: uppercase; margin-top: 2px; }
    .doc-label { text-align: right; }
    .doc-label span { display: block; color: #64748b; font-size: 10px; font-weight: 600; text-transform: uppercase; }
    .doc-label strong { display: block; color: #1e293b; font-size: 13px; font-weight: 600; margin-top: 4px; }
    .header-title { border-top: 1px solid #e2e8f0; padding-top: 28px; }
    .header-title h1 { font-family: 'Playfair Display', serif; color: #1e293b; font-size: 38px; font-weight: 700; }
    .header-title h1 span { color: #475569; }
    .header-title p { color: #64748b; font-size: 13px; margin-top: 10px; }
    .accent-stripe { height: 3px; background: #e2e8f0; }
    .info-section { padding: 36px 48px; background: #fafafa; border-bottom: 1px solid #e2e8f0; }
    .info-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 24px; }
    .info-block h3 { font-size: 10px; font-weight: 600; text-transform: uppercase; color: #64748b; margin-bottom: 8px; }
    .info-block p { font-size: 14px; color: #334155; line-height: 1.6; }
    .product-section { padding: 40px 48px; border-bottom: 1px solid #e2e8f0; background: #ffffff; }
    .section-label { font-size: 10px; font-weight: 600; text-transform: uppercase; color: #475569; margin-bottom: 20px; }
    .terminal-card { border: 1px solid #e2e8f0; border-radius: 6px; overflow: hidden; margin-bottom: 16px; }
    .terminal-card-header { background: #fafafa; padding: 16px 24px; display: flex; align-items: center; gap: 14px; border-bottom: 1px solid #e2e8f0; }
    .terminal-card-body { padding: 20px 24px; display: flex; align-items: center; justify-content: space-between; }
    .spec-item { text-align: center; }
    .spec-item .val { font-size: 18px; font-weight: 700; color: #1e293b; }
    .spec-item .lbl { font-size: 10px; color: #94a3b8; text-transform: uppercase; }
    .price-tag { background: #ffffff; border: 1px solid #cbd5e1; color: #1e293b; padding: 12px 22px; border-radius: 6px; font-family: 'Playfair Display', serif; font-size: 22px; font-weight: 700; text-align: center; }
    .price-tag span { font-size: 11px; color: #64748b; display: block; font-family: 'DM Sans', sans-serif; font-weight: 400; margin-top: 2px; }
    .table-section { padding: 40px 48px; border-bottom: 1px solid #e2e8f0; background: #fafafa; }
    .table-section h2 { font-family: 'Playfair Display', serif; font-size: 22px; color: #1e293b; }
    .table-section .subtitle { font-size: 13px; color: #64748b; margin-bottom: 24px; }
    .rates-table { width: 100%; border-collapse: collapse; font-size: 12px; border-radius: 6px; overflow: hidden; border: 1px solid #e2e8f0; }
    .rates-table thead tr { background: #fafafa; border-bottom: 1px solid #e2e8f0; }
    .rates-table thead th { padding: 15px 10px; color: #1e293b; font-weight: 600; font-size: 10px; text-transform: uppercase; text-align: center; }
    .rates-table tbody td { padding: 14px 10px; text-align: center; color: #334155; border-right: 1px solid #e2e8f0; }
    .rates-table tbody tr { border-bottom: 1px solid #e2e8f0; }
    .rates-table tbody td.editable { color: #64748b; font-style: italic; }
    .notes-section { padding: 28px 48px; background: #ffffff; border-bottom: 1px solid #e2e8f0; }
    .notes-list { list-style: none; }
    .notes-list li { font-size: 12px; color: #64748b; padding: 5px 0; padding-left: 18px; position: relative; }
    .notes-list li::before { content: '—'; position: absolute; left: 0; color: #94a3b8; }
    .footer { background: #fafafa; padding: 32px 48px; text-align: center; border-top: 1px solid #e2e8f0; }
    .footer .brand-name-small { font-family: 'Playfair Display', serif; color: #475569; font-size: 16px; margin-bottom: 8px; }
    .footer p { color: #64748b; font-size: 11px; line-height: 1.7; }
    .footer a { color: #475569; text-decoration: none; }
  </style>
</head>
<body>
<div class="email-wrapper">
  <div class="header">
    <div class="header-top">
      <div class="brand">
        <div class="brand-icon">💳</div>
        <div>
          <div class="brand-name">PayTech</div>
          <div class="brand-tagline">Soluciones de pago</div>
        </div>
      </div>
      <div class="doc-label">
        <span>Folio</span>
        <strong>#COT-2025-0147</strong>
        <span style="margin-top:6px; color:#94a3b8;">25 de mayo, 2025</span>
      </div>
    </div>
    <div class="header-title">
      <h1>Cotización de<br><span>Terminales</span></h1>
      <p>Propuesta comercial · Válida por 30 días naturales</p>
    </div>
  </div>
  <div class="accent-stripe"></div>
  <div class="info-section">
    <div class="info-grid">
      <div class="info-block">
        <h3>Dirigido a</h3>
        <p><strong>Nombre del Cliente</strong><br>Empresa o Razón Social<br>RFC: XXXX000000XXX<br>ciudad@email.com</p>
      </div>
      <div class="info-block">
        <h3>Ejecutivo de cuenta</h3>
        <p><strong>Nombre del Ejecutivo</strong><br>+52 (55) 0000-0000<br>ejecutivo@paytech.mx</p>
      </div>
    </div>
  </div>
  <div class="product-section">
    <div class="section-label">Productos incluidos</div>
    <div class="terminal-card">
      <div class="terminal-card-header">
        <div class="icon">🖥️</div>
        <div>
          <h4>Terminal de sobremesa</h4>
          <p>Conexión Ethernet / WiFi · Impresora integrada</p>
        </div>
      </div>
      <div class="terminal-card-body">
        <div class="spec-item"><div class="val">4G+WiFi</div><div class="lbl">Conectividad</div></div>
        <div class="spec-item"><div class="val">NFC</div><div class="lbl">Contactless</div></div>
        <div class="spec-item"><div class="val">EMV</div><div class="lbl">Chip+Banda</div></div>
        <div class="price-tag">$0.00<span>c/u + IVA</span></div>
      </div>
    </div>
    <div class="terminal-card">
      <div class="terminal-card-header">
        <div class="icon">📱</div>
        <div>
          <h4>Terminal móvil / POS portátil</h4>
          <p>Batería de larga duración · App Android</p>
        </div>
      </div>
      <div class="terminal-card-body">
        <div class="spec-item"><div class="val">4G+BT</div><div class="lbl">Conectividad</div></div>
        <div class="spec-item"><div class="val">NFC</div><div class="lbl">Contactless</div></div>
        <div class="spec-item"><div class="val">EMV</div><div class="lbl">Chip+Banda</div></div>
        <div class="price-tag">$0.00<span>c/u + IVA</span></div>
      </div>
    </div>
  </div>
  <div class="table-section">
    <div class="section-label">Comisiones y tarifas</div>
    <h2>Tasas por tipo de tarjeta</h2>
    <p class="subtitle">Porcentaje de comisión aplicado a cada transacción según el tipo de plástico utilizado.</p>
    <table class="rates-table">
      <thead>
        <tr>
          <th>Concepto</th>
          <th>Nal. Débito</th>
          <th>Nal. Crédito</th>
          <th>Inter. Débito</th>
          <th>Inter. Crédito</th>
          <th>Amex</th>
          <th>Crypto</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Tasa (%)</td>
          <td class="editable">0.00%</td>
          <td class="editable">0.00%</td>
          <td class="editable">0.00%</td>
          <td class="editable">0.00%</td>
          <td class="editable">0.00%</td>
          <td class="editable">0.00%</td>
        </tr>
        <tr>
          <td>Cuota fija</td>
          <td class="editable">$0.00</td>
          <td class="editable">$0.00</td>
          <td class="editable">$0.00</td>
          <td class="editable">$0.00</td>
          <td class="editable">$0.00</td>
          <td class="editable">$0.00</td>
        </tr>
        <tr>
          <td>MSI</td>
          <td style="color:#cbd5e1;">N/A</td>
          <td class="editable">3, 6, 12</td>
          <td style="color:#cbd5e1;">N/A</td>
          <td class="editable">3, 6</td>
          <td class="editable">3, 6</td>
          <td style="color:#cbd5e1;">N/A</td>
        </tr>
        <tr>
          <td>Dispersión</td>
          <td class="editable">24 hrs</td>
          <td class="editable">24 hrs</td>
          <td class="editable">48 hrs</td>
          <td class="editable">48 hrs</td>
          <td class="editable">48 hrs</td>
          <td class="editable">Inmediato</td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="notes-section">
    <h3>Condiciones y notas</h3>
    <ul class="notes-list">
      <li>Tarifas sujetas a aprobación de crédito y volumen mensual proyectado.</li>
      <li>Instalación y capacitación sin costo adicional.</li>
      <li>Contrato mínimo de 12 meses. Renovación automática.</li>
    </ul>
  </div>
  <div class="footer">
    <div class="brand-name-small">PayTech · Soluciones de Pago</div>
    <p>Av. Reforma 123, Col. Centro · CDMX · ventas@paytech.mx</p>
  </div>
</div>
</body>
</html>`;

export const CON_RENTA_TEMPLATE = COMPRA_SIMPLE_TEMPLATE
  .replace(/\$0\.00<span>c\/u \+ IVA<\/span>/g, '$450.00<span>c/u / mes</span>')
  .replace(/Contrato mínimo de 12 meses\./g, 'Contrato mensual con renta fija de terminal.');

export const PRO_TEMPLATE = COMPRA_SIMPLE_TEMPLATE
  .replace(/PayTech/g, 'PayTech Premium Pro')
  .replace(/0\.00%/g, '1.29%')
  .replace(/\$0\.00/g, '$1.50')
  .replace(/24 hrs/g, 'Mismo Día (12 hrs)');
